module.exports = __webpack_public_path__ + "img/template.b90c291d.svg";